module.exports = __webpack_public_path__ + "static/img/6 自如海燕计划.9907851.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/6 自如海燕计划.png
// module id = e/lr
// module chunks = 1